/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorAvailabilityReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, CorporateStructureLink) {
  'use strict';




  /**
   * The PerformanceIndicatorAvailabilityReport model module.
   * @module model/PerformanceIndicatorAvailabilityReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PerformanceIndicatorAvailabilityReport</code>.
   * @alias module:model/PerformanceIndicatorAvailabilityReport
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>PerformanceIndicatorAvailabilityReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PerformanceIndicatorAvailabilityReport} obj Optional instance to populate.
   * @return {module:model/PerformanceIndicatorAvailabilityReport} The populated <code>PerformanceIndicatorAvailabilityReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'String');
      }
      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Identifier')) {
        obj['Identifier'] = ApiClient.convertToType(data['Identifier'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('ActualPeriodTypes')) {
        obj['ActualPeriodTypes'] = ApiClient.convertToType(data['ActualPeriodTypes'], ['Integer']);
      }
      if (data.hasOwnProperty('BudgetPeriodTypes')) {
        obj['BudgetPeriodTypes'] = ApiClient.convertToType(data['BudgetPeriodTypes'], ['Integer']);
      }
      if (data.hasOwnProperty('ForecastPeriodTypes')) {
        obj['ForecastPeriodTypes'] = ApiClient.convertToType(data['ForecastPeriodTypes'], ['Integer']);
      }
      if (data.hasOwnProperty('GoalPeriodTypes')) {
        obj['GoalPeriodTypes'] = ApiClient.convertToType(data['GoalPeriodTypes'], ['Integer']);
      }
    }
    return obj;
  }

  /**
   * @member {String} ID
   * @default ''
   */
  exports.prototype['ID'] = '';
  /**
   * @member {Integer} IndicatorID
   * @default 0
   */
  exports.prototype['IndicatorID'] = 0;
  /**
   * @member {String} Identifier
   * @default ''
   */
  exports.prototype['Identifier'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Array.<Integer>} ActualPeriodTypes
   */
  exports.prototype['ActualPeriodTypes'] = undefined;
  /**
   * @member {Array.<Integer>} BudgetPeriodTypes
   */
  exports.prototype['BudgetPeriodTypes'] = undefined;
  /**
   * @member {Array.<Integer>} ForecastPeriodTypes
   */
  exports.prototype['ForecastPeriodTypes'] = undefined;
  /**
   * @member {Array.<Integer>} GoalPeriodTypes
   */
  exports.prototype['GoalPeriodTypes'] = undefined;



  return exports;
}));


